module.exports = __webpack_public_path__ + "img/p2p-line.7ec440a8.svg";